document.addEventListener("DOMContentLoaded", ()=>{
    const buttons = document.querySelectorAll('.Button');
    const angleFactor = 36;

    window.addEventListener('global:align', registerButtons);    

    function registerButtons(){
        // get only buttons that are not already registered
        let newButtons = document.querySelectorAll('.Button:not([data-registered])');
        newButtons.forEach((button) => {
            initButton(button);
        });
    }

    buttons.forEach((button) => {
        initButton(button);
    });

    function initButton(button){
        button.dataset.registered = true;

        // track mouse position
        button.addEventListener('mouseenter', onEnterLeave);
        button.addEventListener('mouseleave', onEnterLeave);
        
        function onEnterLeave(e){
            const rect = button.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const centerX = rect.width / 2;
            const angle = (centerX - x) / centerX * angleFactor;

            button.style.setProperty('--x', x + 'px');
            button.style.setProperty('--y', y + 'px');
            button.style.setProperty('--angle', angle + 'deg');
        }
    }
});